import React from 'react';
const CarouselSVG = ({ color = 'black', className, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className={className}
      {...props}
    >
      <path
        d="M4.26758 6.06669C4.26758 3.5211 4.26758 2.24831 5.05839 1.4575C5.8492 0.666687 7.12199 0.666687 9.66758 0.666687C12.2131 0.666687 13.4859 0.666687 14.2767 1.4575C15.0676 2.24831 15.0676 3.5211 15.0676 6.06669V13.2667C15.0676 15.8122 15.0676 17.085 14.2767 17.8759C13.4859 18.6667 12.2131 18.6667 9.66758 18.6667C7.12199 18.6667 5.8492 18.6667 5.05839 17.8759C4.26758 17.085 4.26758 15.8122 4.26758 13.2667V6.06669Z"
        stroke={color}
        strokeWidth="1.2"
      />
      <path
        d="M15.0684 16.4167C16.3284 16.4167 16.9585 16.4167 17.4399 16.1714C17.8632 15.9557 18.2074 15.6115 18.4231 15.1882C18.6684 14.7069 18.6684 14.0768 18.6684 12.8167V6.51669C18.6684 5.25657 18.6684 4.62651 18.4231 4.1452C18.2074 3.72184 17.8632 3.37764 17.4399 3.16192C16.9585 2.91669 16.3284 2.91669 15.0684 2.91669"
        stroke={color}
        strokeWidth="1.2"
      />
      <path
        d="M4.26797 16.4167C3.00785 16.4167 2.37779 16.4167 1.89649 16.1714C1.47313 15.9557 1.12892 15.6115 0.913201 15.1882C0.667969 14.7069 0.667969 14.0768 0.667969 12.8167V6.51669C0.667969 5.25657 0.667969 4.62651 0.913201 4.1452C1.12892 3.72184 1.47313 3.37764 1.89649 3.16192C2.37779 2.91669 3.00785 2.91669 4.26797 2.91669"
        stroke={color}
        strokeWidth="1.2"
      />
    </svg>
  );
};

export default CarouselSVG;
